interface KilnShellMaterialProps {
  x: number
  width: number
  height: number
  color: string
}

export const KilnShellMaterial: React.FC<KilnShellMaterialProps> = ({x, width, height, color}) => {
  return <rect x={x} y={0} width={width} height={height} fill={color} />
}
